import { Link } from "react-router-dom";
import Spacer from "../../components/Spacer";
import { useState } from "react";
import { apiUrl, executeRequest, getToken } from "../../functions/requests";
import { usePageState } from "../../Layout";
import FormInput from "../../components/FormInput";
import Button from "../../components/Button";
import Message from "../../components/Message";

export default function Projects() {
  const { pageState, setPageState } = usePageState();
  const [userData, setUserData] = useState(pageState.userData);
  const [loading, setLoading] = useState(false);

  // Initialize idea as part of pageState if not already present
  const idea = pageState.idea || "";
  const setIdea = (newIdea) => {
    setPageState({ ...pageState, idea: newIdea });
  };

  // Message
  const [message, setMessage] = useState("");
  const [messageSection, setMessageSection] = useState("");

  const addIdea = async () => {
    if (loading || idea.length === 0) return;
    setLoading(true);
    try {
      await executeRequest(
        apiUrl + "ideas",
        "POST",
        JSON.stringify({
          content: idea,
        }),
        {
          Authorization: "Bearer " + getToken(),
          "Content-type": "application/json",
        },
        (data) => {
          console.log(data);
          setIdea("");
          setMessageSection("success");
          setMessage("Thank you for your idea. It has been sent.");
        },
        (error) => {
          console.log(error);
          setMessageSection("danger");
          setMessage(
            "There was a problem while sending your idea. Please try again."
          );
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 className="page-title">Projects</h1>
      <table>
        <thead>
          <tr>
            <th>Project</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Link to="eshops">Eshops</Link>
            </td>
            <td>
              Empower your business with customizable and pre-made e-commerce
              solutions.
            </td>
          </tr>
          <tr>
            <td>
              <Link to="eshops">Websites</Link>
            </td>
            <td>
              Showcase your business to the right customers by using our
              top-notch websites, crafted to suit your needs.
            </td>
          </tr>
          <tr>
            <td>
              <Link to="online-menu">Online Menu</Link>
            </td>
            <td>
              An Online Catalogue to show any product to your customers. Scan
              the QR Code, view the catalogue and even order on the spot! Save
              time and money from your people by using this feature.
            </td>
          </tr>
          <tr>
            <td>
              <Link to="loyalty-program">Loyalty Program</Link>
            </td>
            <td>
              Reward your customers for their repeating purchases and create
              long-term relationships with them. Can be used either as stamps
              (ideal for coffee shops) or as points (ideal for e-shops and
              applications). Fully customizable and easy-to-use.
            </td>
          </tr>
          <tr>
            <td>
              <Link to="booking">Booking</Link>
            </td>
            <td>
              Receive your customers' bookings via our platform. Fully
              customizable, functional and easy-to-use, it allows your both your
              customers and your personel to get the most out of this software.
            </td>
          </tr>
          <tr>
            <td>
              <Link to="real-estate">Real Estate Agenda</Link>
            </td>
            <td>
              Empower your Agency and your Agents with our analytical and
              easy-to-use software. Property listing, customer analytics, price
              calculator and more tools enable you and your team to reach higher
              productivity.
            </td>
          </tr>
          <tr>
            <td>
              <Link to="tickets">Tickets</Link>
            </td>
            <td>
              Organizing events was never easier and more professional. With our
              software, you can customize tiers, details and pricing. The only
              device you need is an Android phone to scan the tickets.
            </td>
          </tr>
          <tr>
            <td>
              <div>Got an idea? Share it with us!</div>
              <div>
                Write it down to the box in the right and we'll check it!
              </div>
            </td>
            <td>
              <div
                style={{ width: "100%", display: "flex", gap: "var(--spaceS)" }}
              >
                <FormInput
                  type="text"
                  value={idea}
                  onChanged={(value) => setIdea(value)}
                />
                <Button
                  text="Send"
                  onClicked={() => addIdea()}
                  loading={loading}
                  disabled={loading || idea.length === 0}
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      {message.length > 0 && (
        <Message
          type={messageSection}
          message={message}
          onClosed={() => {
            setMessage("");
            setMessageSection("");
          }}
        />
      )}
    </div>
  );
}
